import { Bar, BarChart, CartesianGrid, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { CompareResult } from "models/hr-dashboard";

interface CompareChartProps {
    data: CompareResult;
}

// Stacked bars: employees + consultants at the end of each month
const CompareChart = ({ data }: CompareChartProps) => {
    const rows = data.months
        .filter(m => m.total !== null)
        .map(m => ({ label: m.label, employees: m.employees, consultants: m.consultants, total: m.total }));

    if (rows.length === 0) return null;

    return (
        <div style={{ width: "100%" }}>
            <h4 className="text-muted mb-2">Employees vs Consultants</h4>
            <div style={{ width: "100%", height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={rows} margin={{ top: 20, right: 10, left: 10, bottom: 10 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="label" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="employees" name="Employees" stackId="hc" fill="#4472c4">
                            <LabelList dataKey="employees" position="center" fill="#fff" />
                        </Bar>
                        <Bar dataKey="consultants" name="Consultants" stackId="hc" fill="#29A9E0">
                            <LabelList dataKey="consultants" position="center" fill="#fff" />
                            <LabelList dataKey="total" position="top" />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default CompareChart;
